import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-20" aria-labelledby="category-heading">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 border border-primary-500/50 text-primary-500 text-xs font-medium rounded-full mb-4 whitespace-nowrap">
            热门频道
          </span>
          <h2
            id="category-heading"
            className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3"
          >
            你想吃的瓜
            <br />
            这里全都有
          </h2>
          <p className="text-base text-foreground-600 max-w-lg mx-auto">
            六大热门频道，覆盖明星八卦、网红大瓜、塌房现场、影视解析等最全吃瓜品类
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block p-6 md:p-7 rounded-xl bg-background-100 hover:bg-primary-500 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-background-200 group-hover:bg-background-50/20 flex items-center justify-center mb-5 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-950 group-hover:text-background-50 mb-2 transition-colors duration-300">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 group-hover:text-background-50/80 transition-colors duration-300 leading-relaxed">
                {cat.description}
              </p>
              <div className="flex items-center gap-2 mt-4 text-xs text-foreground-500 group-hover:text-background-50/60 transition-colors duration-300">
                <span>{cat.count.toLocaleString()} 篇内容</span>
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}